var kickstart = {
  slide2id: function (id) {
    jQuery('html, body').animate({ scrollTop: jQuery(id).offset().top }, 200);
  },

  extend: function (extender) {
    jQuery.extend(kickstart, extender);
  },

  getParent: function (context, parentSelector, depth) {
    depth = typeof depth !== 'undefined' ? depth : 5;
    var parent = jQuery(context).parent();
    if (typeof parent === 'undefined' || depth <= 0) {
      console.log(
        'Was not able to select parent with selector "' + parentSelector + '".'
      );
      return undefined;
    }

    if (jQuery(parent).is(parentSelector)) {
      return parent;
    }

    return kickstart.getParent(parent, parentSelector, depth - 1);
  },

  readParentData: function (context, parentSelector, dataName, depth) {
    depth = typeof depth !== 'undefined' ? depth : 5;
    var parent = kickstart.getParent(context, parentSelector, depth);
    if (typeof parent === 'undefined') {
      return undefined;
    }
    return parent.data(dataName);
  },
};

window.kickstartjs = kickstart;

jQuery(document).ready(function ($) {
  //if(jQuery(".load-norms").length) getData('norms');
  if (jQuery('.load-news').length) {
    var postType = jQuery('[data-post-type]').data('post-type');
    getData(postType);
  }
  if (jQuery('.load-jobs').length) {
    var type = jQuery('.load-jobs').attr('data-type');
    getData('jobs', type);
  }

  if (jQuery('#site').attr('data-browser') == 'MSIE11') {
    jQuery(function () {
      new FilmRoll({
        container: '#history-slider-ie11',
        scroll: false,
        pager: false,
        configure_load: true,
        shuttle_width: 0,
      });
    });
  }

  headerSpace();
  scrolledNavigation();
  jQuery(window).resize(function () {
    headerSpace();
  });

  if (jQuery('.employee-wrapper').length) {
    var width = 0;
    var count = jQuery('.employee-wrapper .employee-background img').length;
    jQuery('.employee-wrapper .employee-background img').each(function (index) {
      var ele = jQuery(this);
      width += ele.width();

      if (index + 1 == count) {
        $('.employee-wrapper .employee-background').width(width + 3);
      }
    });
  }

  jQuery('h2, h3, h4, h5, h6').not('.nobreak').addClass('hyphenate');
  var url = jQuery("meta[name='site-url']").attr('content');
  //jQuery.getScript(url + '/wp-content/themes/nanogy/static/js/hyphenate.js');

  jQuery('.page-content p').has('iframe').css('text-align', 'center');

  jQuery('.search-bar form').submit(function (e) {
    var form = jQuery(this);
    var text = jQuery("input[name='s']", this).val();
    text = jQuery.trim(text);
    if (text.length < 3) {
      alert(form.attr('data-error-length'));
      return false;
    }

    var stopwords =
      'a,about,above,across,after,afterwards,again,against,all,almost,alone,along,already,also,although,always,am,among,amongst,amoungst,amount,an,and,another,any,anyhow,anyone,anything,anyway,anywhere,are,around,as,at,back,be,became,because,become,becomes,becoming,been,before,beforehand,behind,being,below,beside,besides,between,beyond,bill,both,bottom,but,by,call,can,cannot,cant,co,computer,con,could,couldnt,cry,de,describe,detail,do,done,down,due,during,each,eg,eight,either,eleven,else,elsewhere,empty,enough,etc,even,ever,every,everyone,everything,everywhere,except,few,fifteen,fify,fill,find,fire,first,five,for,former,formerly,forty,found,four,from,front,full,further,get,give,go,had,has,hasnt,have,he,hence,her,here,hereafter,hereby,herein,hereupon,hers,herse",him,himse",his,how,however,hundred,i,ie,if,in,inc,indeed,interest,into,is,it,its,itse",keep,last,latter,latterly,least,less,ltd,made,many,may,me,meanwhile,might,mill,mine,more,moreover,most,mostly,move,much,must,my,myse",name,namely,neither,never,nevertheless,next,nine,no,nobody,none,noone,nor,not,nothing,now,nowhere,of,off,often,on,once,one,only,onto,or,other,others,otherwise,our,ours,ourselves,out,over,own,part,per,perhaps,please,put,rather,re,same,see,seem,seemed,seeming,seems,serious,several,she,should,show,side,since,sincere,six,sixty,so,some,somehow,someone,something,sometime,sometimes,somewhere,still,such,system,take,ten,than,that,the,their,them,themselves,then,thence,there,thereafter,thereby,therefore,therein,thereupon,these,they,thick,thin,third,this,those,though,three,through,throughout,thru,thus,to,together,too,top,toward,towards,twelve,twenty,two,un,under,until,up,upon,us,very,via,was,we,well,were,what,whatever,when,whence,whenever,where,whereafter,whereas,whereby,wherein,whereupon,wherever,whether,which,while,whither,who,whoever,whole,whom,whose,why,will,with,within,without,would,yet,you,your,yours,yourself,yourselves,ab,aber,abermaliges,abermals,abgerufen,abgerufene,abgerufener,abgerufenes,abgesehen,acht,aehnlich,aehnliche,aehnlichem,aehnlichen,aehnlicher,aehnliches,aehnlichste,aehnlichstem,aehnlichsten,aehnlichster,aehnlichstes,aeusserst,aeusserste,aeusserstem,aeussersten,aeusserster,aeusserstes,ähnlich,ähnliche,ähnlichem,ähnlichen,ähnlicher,ähnliches,ähnlichst,ähnlichste,ähnlichstem,ähnlichsten,ähnlichster,ähnlichstes,alle,allein,alleine,allem,allemal,allen,allenfalls,allenthalben,aller,allerdings,allerlei,alles,allesamt,allg,allg.,allgemein,allgemeine,allgemeinem,allgemeinen,allgemeiner,allgemeines,allgemeinste,allgemeinstem,allgemeinsten,allgemeinster,allgemeinstes,allmählich,allzeit,allzu,als,alsbald,also,am,an,and,andauernd,andauernde,andauerndem,andauernden,andauernder,andauerndes,ander,andere,anderem,anderen,anderenfalls,anderer,andererseits,anderes,anderm,andern,andernfalls,anderr,anders,anderst,anderweitig,anderweitige,anderweitigem,anderweitigen,anderweitiger,anderweitiges,anerkannt,anerkannte,anerkannter,anerkanntes,anfangen,anfing,angefangen,angesetze,angesetzt,angesetzten,angesetzter,ans,anscheinend,ansetzen,ansonst,ansonsten,anstatt,anstelle,arbeiten,auch,auf,aufgehört,aufgrund,aufhören,aufhörte,aufzusuchen,augenscheinlich,augenscheinliche,augenscheinlichem,augenscheinlichen,augenscheinlicher,augenscheinliches,augenscheinlichst,augenscheinlichste,augenscheinlichstem,augenscheinlichsten,augenscheinlichster,augenscheinlichstes,aus,ausdrücken,ausdrücklich,ausdrückliche,ausdrücklichem,ausdrücklichen,ausdrücklicher,ausdrückliches,ausdrückt,ausdrückte,ausgenommen,ausgenommene,ausgenommenem,ausgenommenen,ausgenommener,ausgenommenes,ausgerechnet,ausgerechnete,ausgerechnetem,ausgerechneten,ausgerechneter,ausgerechnetes,ausnahmslos,ausnahmslose,ausnahmslosem,ausnahmslosen,ausnahmsloser,ausnahmsloses,außen,ausser,ausserdem,außerhalb,äusserst,äusserste,äusserstem,äussersten,äusserster,äusserstes,author,autor,baelde,bald,bälde,bearbeite,bearbeiten,bearbeitete,bearbeiteten,bedarf,bedürfen,bedurfte,been,befahl,befiehlt,befiehlte,befohlene,befohlens,befragen,befragte,befragten,befragter,begann,beginnen,begonnen,behalten,behielt,bei,beide,beidem,beiden,beider,beiderlei,beides,beim,beinahe,beisammen,beispielsweise,beitragen,beitrugen,bekannt,bekannte,bekannter,bekanntlich,bekanntliche,bekanntlichem,bekanntlichen,bekanntlicher,bekanntliches,bekennen,benutzt,bereits,berichten,berichtet,berichtete,berichteten,besonders,besser,bessere,besserem,besseren,besserer,besseres,bestehen,besteht,bestenfalls,bestimmt,bestimmte,bestimmtem,bestimmten,bestimmter,bestimmtes,beträchtlich,beträchtliche,beträchtlichem,beträchtlichen,beträchtlicher,beträchtliches,betraechtlich,betraechtliche,betraechtlichem,betraechtlichen,betraechtlicher,betraechtliches,betreffend,betreffende,betreffendem,betreffenden,betreffender,betreffendes,bevor,bez,bez.,bezgl,bezgl.,bezueglich,bezüglich,bietet,bin,bis,bisher,bisherige,bisherigem,bisherigen,bisheriger,bisheriges,bislang,bisschen,bist,bitte,bleiben,bleibt,blieb,bloss,böden,boeden,brachte,brachten,brauchen,braucht,bräuchte,bringen,bsp,bsp.,bspw,bspw.,bzw,bzw.,ca,ca.,circa,da,dabei,dadurch,dafuer,dafür,dagegen,daher,dahin,dahingehend,dahingehende,dahingehendem,dahingehenden,dahingehender,dahingehendes,dahinter,damalige,damaligem,damaligen,damaliger,damaliges,damals,damit,danach,daneben,dank,danke,danken,dann,dannen,daran,darauf,daraus,darf,darfst,darin,darüber,darüberhinaus,darueber,darueberhinaus,darum,darunter,das,daß,dasselbe,Dat,davon,davor,dazu,dazwischen,dein,deine,deinem,deinen,deiner,deines,dem,demgegenüber,demgegenueber,demgemaess,demgemäss,demnach,demselben,den,denen,denkbar,denkbare,denkbarem,denkbaren,denkbarer,denkbares,denn,dennoch,denselben,der,derart,derartig,derartige,derartigem,derartigen,derartiger,derem,deren,derer,derjenige,derjenigen,derselbe,derselben,derzeit,derzeitig,derzeitige,derzeitigem,derzeitigen,derzeitiges,des,deshalb,desselben,dessen,dessenungeachtet,desto,desungeachtet,deswegen,dich,die,diejenige,diejenigen,dies,diese,dieselbe,dieselben,diesem,diesen,dieser,dieses,diesseitig,diesseitige,diesseitigem,diesseitigen,diesseitiger,diesseitiges,diesseits,dinge,dir,direkt,direkte,direkten,direkter,doch,doppelt,dort,dorther,dorthin,dran,drauf,drei,dreißig,drin,dritte,drüber,drueber,drum,drunter,du,duerfte,duerften,duerftest,duerftet,dunklen,durch,durchaus,durchweg,durchwegs,dürfen,durfte,dürfte,durften,dürften,durftest,dürftest,durftet,dürftet,eben,ebenfalls,ebenso,ect,ect.,ehe,eher,eheste,ehestem,ehesten,ehester,ehestes,eigen,eigene,eigenem,eigenen,eigener,eigenes,eigenst,eigentlich,eigentliche,eigentlichem,eigentlichen,eigentlicher,eigentliches,ein,einbaün,eine,einem,einen,einer,einerlei,einerseits,eines,einfach,einführen,einführte,einführten,eingesetzt,einig,einige,einigem,einigen,einiger,einigermaßen,einiges,einmal,einmalig,einmalige,einmaligem,einmaligen,einmaliger,einmaliges,eins,einseitig,einseitige,einseitigen,einseitiger,einst,einstmals,einzig,empfunden,ende,entgegen,entlang,entsprechend,entsprechende,entsprechendem,entsprechenden,entsprechender,entsprechendes,entweder,er,ergänze,ergänzen,ergänzte,ergänzten,ergo,erhält,erhalten,erhielt,erhielten,erneut,eröffne,eröffnen,eröffnet,eröffnete,eröffnetes,erscheinen,erst,erste,erstem,ersten,erster,erstere,ersterem,ersteren,ersterer,ersteres,erstes,es,etc,etc.,etliche,etlichem,etlichen,etlicher,etliches,etwa,etwaige,etwas,euch,euer,eure,eurem,euren,eurer,eures,euretwegen,fall,falls,fand,fast,ferner,fertig,finde,finden,findest,findet,folgend,folgende,folgendem,folgenden,folgender,folgendermassen,folgendes,folglich,for,fordern,fordert,forderte,forderten,fort,fortsetzen,fortsetzt,fortsetzte,fortsetzten,fragte,frau,frei,freie,freier,freies,fuer,fuers,fünf,für,fürs,gab,gaenzlich,gaenzliche,gaenzlichem,gaenzlichen,gaenzlicher,gaenzliches,gängig,gängige,gängigen,gängiger,gängiges,ganz,ganze,ganzem,ganzen,ganzer,ganzes,gänzlich,gänzliche,gänzlichem,gänzlichen,gänzlicher,gänzliches,gar,gbr,geb,geben,geblieben,gebracht,gedurft,geehrt,geehrte,geehrten,geehrter,gefallen,gefälligst,gefällt,gefiel,gegeben,gegen,gegenüber,gegenueber,gehabt,gehalten,gehen,geht,gekommen,gekonnt,gemacht,gemaess,gemäss,gemeinhin,gemocht,genau,genommen,genug,gepriesener,gepriesenes,gerade,gern,gesagt,gesehen,gestern,gestrige,getan,geteilt,geteilte,getragen,getrennt,gewesen,gewiss,gewisse,gewissem,gewissen,gewisser,gewissermaßen,gewisses,gewollt,geworden,ggf,ggf.,gib,gibt,gilt,gleich,gleiche,gleichem,gleichen,gleicher,gleiches,gleichsam,gleichste,gleichstem,gleichsten,gleichster,gleichstes,gleichwohl,gleichzeitig,gleichzeitige,gleichzeitigem,gleichzeitigen,gleichzeitiger,gleichzeitiges,glücklicherweise,gluecklicherweise,gmbh,gottseidank,gratulieren,gratuliert,gratulierte,groesstenteils,grösstenteils,gruendlich,gründlich,gut,gute,guten,hab,habe,haben,habt,haette,haeufig,haeufige,haeufigem,haeufigen,haeufiger,haeufigere,haeufigeren,haeufigerer,haeufigeres,halb,hallo,halten,hast,hat,hätt,hatte,hätte,hatten,hätten,hattest,hattet,häufig,häufige,häufigem,häufigen,häufiger,häufigere,häufigeren,häufigerer,häufigeres,hen,her,heraus,herein,herum,heute,heutige,heutigem,heutigen,heutiger,heutiges,hier,hier,hierbei,hiermit,hiesige,hiesigem,hiesigen,hiesiger,hiesiges,hin,hindurch,hinein,hingegen,hinlanglich,hinlänglich,hinten,hintendran,hinter,hinterher,hinterm,hintern,hinunter,hoch,höchst,höchstens,http,hundert,ich,igitt,ihm,ihn,ihnen,ihr,ihre,ihrem,ihren,ihrer,ihres,ihretwegen,ihrige,ihrigen,ihriges,im,immer,immerhin,immerwaehrend,immerwaehrende,immerwaehrendem,immerwaehrenden,immerwaehrender,immerwaehrendes,immerwährend,immerwährende,immerwährendem,immerwährenden,immerwährender,immerwährendes,immerzu,important,in,indem,indessen,Inf.,info,infolge,infolgedessen,information,innen,innerhalb,innerlich,ins,insbesondere,insgeheim,insgeheime,insgeheimer,insgesamt,insgesamte,insgesamter,insofern,inzwischen,irgend,irgendein,irgendeine,irgendeinem,irgendeiner,irgendeines,irgendetwas,irgendjemand,irgendjemandem,irgendwann,irgendwas,irgendwelche,irgendwen,irgendwenn,irgendwer,irgendwie,irgendwo,irgendwohin,ist,ja,jaehrig,jaehrige,jaehrigem,jaehrigen,jaehriger,jaehriges,jährig,jährige,jährigem,jährigen,jähriges,je,jede,jedem,jeden,jedenfalls,jeder,jederlei,jedes,jedesmal,jedoch,jeglichem,jeglichen,jeglicher,jegliches,jemals,jemand,jemandem,jemanden,jemandes,jene,jenem,jenen,jener,jenes,jenseitig,jenseitigem,jenseitiger,jenseits,jetzt,jung,junge,jungem,jungen,junger,junges,kaeumlich,kam,kann,kannst,kaum,käumlich,kein,keine,keinem,keinen,keiner,keinerlei,keines,keineswegs,klar,klare,klaren,klares,klein,kleinen,kleiner,kleines,koennen,koennt,koennte,koennten,koenntest,koenntet,komme,kommen,kommt,konkret,konkrete,konkreten,konkreter,konkretes,könn,können,könnt,konnte,könnte,konnten,könnten,konntest,könntest,konntet,könntet,kuenftig,kuerzlich,kuerzlichst,künftig,kürzlich,kürzlichst,laengst,lag,lagen,langsam,längst,längstens,lassen,laut,lediglich,leer,legen,legte,legten,leicht,leider,lesen,letze,letzte,letzten,letztendlich,letztens,letztere,letzterem,letzterer,letzteres,letztes,letztlich,lichten,liegt,liest,links,mache,machen,machst,macht,machte,machten,mag,magst,mal,man,manch,manche,manchem,manchen,mancher,mancherlei,mancherorts,manches,manchmal,mann,margin,massgebend,massgebende,massgebendem,massgebenden,massgebender,massgebendes,massgeblich,massgebliche,massgeblichem,massgeblichen,massgeblicher,mehr,mehrere,mehrerer,mehrfach,mehrmalig,mehrmaligem,mehrmaliger,mehrmaliges,mein,meine,meinem,meinen,meiner,meines,meinetwegen,meins,meist,meiste,meisten,meistens,meistenteils,meta,mich,mindestens,mir,mit,miteinander,mitgleich,mithin,mitnichten,mittels,mittelst,mitten,mittig,mitunter,mitwohl,mochte,möchte,möchten,möchtest,moechte,moeglich,moeglichst,moeglichste,moeglichstem,moeglichsten,moeglichster,mögen,möglich,mögliche,möglichen,möglicher,möglicherweise,möglichst,möglichste,möglichstem,möglichsten,möglichster,morgen,morgige,muessen,muesst,muesste,muss,müssen,musst,müßt,musste,müsste,mussten,müssten,nach,nachdem,nacher,nachher,nachhinein,nächste,nacht,naechste,naemlich,nahm,nämlich,naturgemaess,naturgemäss,natürlich,ncht,neben,nebenan,nehmen,nein,neu,neue,neuem,neuen,neuer,neuerdings,neuerlich,neuerliche,neuerlichem,neuerlicher,neuerliches,neues,neulich,neun,nicht,nichts,nichtsdestotrotz,nichtsdestoweniger,nie,niemals,niemand,niemandem,niemanden,niemandes,nimm,nimmer,nimmt,nirgends,nirgendwo,noch,noetigenfalls,nötigenfalls,nun,nur,nutzen,nutzt,nützt,nutzung,ob,oben,ober,oberen,oberer,oberhalb,oberste,obersten,oberster,obgleich,obs,obschon,obwohl,oder,oefter,oefters,off,offenkundig,offenkundige,offenkundigem,offenkundigen,offenkundiger,offenkundiges,offensichtlich,offensichtliche,offensichtlichem,offensichtlichen,offensichtlicher,offensichtliches,oft,öfter,öfters,oftmals,ohne,ohnedies,online,paar,partout,per,persoenlich,persoenliche,persoenlichem,persoenlicher,persoenliches,persönlich,persönliche,persönlicher,persönliches,pfui,ploetzlich,ploetzliche,ploetzlichem,ploetzlicher,ploetzliches,plötzlich,plötzliche,plötzlichem,plötzlicher,plötzliches,pro,quasi,reagiere,reagieren,reagiert,reagierte,recht,rechts,regelmäßig,reichlich,reichliche,reichlichem,reichlichen,reichlicher,restlos,restlose,restlosem,restlosen,restloser,restloses,richtiggehend,richtiggehende,richtiggehendem,richtiggehenden,richtiggehender,richtiggehendes,rief,rund,rundheraus,rundum,runter,sage,sagen,sagt,sagte,sagten,sagtest,sagtet,samt,sämtliche,sang,sangen,sattsam,schätzen,schätzt,schätzte,schätzten,scheinbar,scheinen,schlechter,schlicht,schlichtweg,schließlich,schlussendlich,schnell,schon,schreibe,schreiben,schreibens,schreiber,schwerlich,schwerliche,schwerlichem,schwerlichen,schwerlicher,schwerliches,schwierig,sechs,sect,sehe,sehen,sehr,sehrwohl,seht,sei,seid,seien,seiest,seiet,sein,seine,seinem,seinen,seiner,seines,seit,seitdem,seite,seiten,seither,selbe,selben,selber,selbst,selbstredend,selbstredende,selbstredendem,selbstredenden,selbstredender,selbstredendes,seltsamerweise,senke,senken,senkt,senkte,senkten,setzen,setzt,setzte,setzten,sich,sicher,sicherlich,sie,sieben,siebte,siehe,sieht,sind,singen,singt,so,sobald,sodaß,soeben,sofern,sofort,sog,sogar,sogleich,solange,solc,solc hen,solch,solche,solchem,solchen,solcher,solches,soll,sollen,sollst,sollt,sollte,sollten,solltest,solltet,somit,sondern,sonst,sonstig,sonstige,sonstigem,sonstiger,sonstwo,sooft,soviel,soweit,sowie,sowieso,sowohl,später,spielen,startet,startete,starteten,statt,stattdessen,steht,steige,steigen,steigt,stellenweise,stellenweisem,stellenweisen,stets,stieg,stiegen,such,suchen,tages,tat,tät,tatsächlich,tatsächlichen,tatsächlicher,tatsächliches,tatsaechlich,tatsaechlichen,tatsaechlicher,tatsaechliches,tausend,teile,teilen,teilte,teilten,tief,titel,toll,total,trage,tragen,trägt,trotzdem,trug,tun,tust,tut,txt,übel,über,überall,überallhin,überaus,überdies,überhaupt,überll,übermorgen,üblicherweise,übrig,übrigens,ueber,ueberall,ueberallhin,ueberaus,ueberdies,ueberhaupt,uebermorgen,ueblicherweise,uebrig,uebrigens,um,ums,umso,umstaendehalber,umständehalber,unbedingt,unbedingte,unbedingter,unbedingtes,und,unerhoert,unerhoerte,unerhoertem,unerhoerten,unerhoerter,unerhoertes,unerhört,unerhörte,unerhörtem,unerhörten,unerhörter,unerhörtes,ungefähr,ungemein,ungewoehnlich,ungewoehnliche,ungewoehnlichem,ungewoehnlichen,ungewoehnlicher,ungewoehnliches,ungewöhnlich,ungewöhnliche,ungewöhnlichem,ungewöhnlichen,ungewöhnlicher,ungewöhnliches,ungleich,ungleiche,ungleichem,ungleichen,ungleicher,ungleiches,unmassgeblich,unmassgebliche,unmassgeblichem,unmassgeblichen,unmassgeblicher,unmassgebliches,unmoeglich,unmoegliche,unmoeglichem,unmoeglichen,unmoeglicher,unmoegliches,unmöglich,unmögliche,unmöglichen,unmöglicher,unnötig,uns,unsaeglich,unsaegliche,unsaeglichem,unsaeglichen,unsaeglicher,unsaegliches,unsagbar,unsagbare,unsagbarem,unsagbaren,unsagbarer,unsagbares,unsäglich,unsägliche,unsäglichem,unsäglichen,unsäglicher,unsägliches,unse,unsem,unsen,unser,unser,unsere,unserem,unseren,unserer,unseres,unserm,unses,unsre,unsrem,unsren,unsrer,unsres,unstreitig,unstreitige,unstreitigem,unstreitigen,unstreitiger,unstreitiges,unten,unter,unterbrach,unterbrechen,untere,unterem,unteres,unterhalb,unterste,unterster,unterstes,unwichtig,unzweifelhaft,unzweifelhafte,unzweifelhaftem,unzweifelhaften,unzweifelhafter,unzweifelhaftes,usw,usw.,vergangen,vergangene,vergangener,vergangenes,vermag,vermögen,vermutlich,vermutliche,vermutlichem,vermutlichen,vermutlicher,vermutliches,veröffentlichen,veröffentlicher,veröffentlicht,veröffentlichte,veröffentlichten,veröffentlichtes,verrate,verraten,verriet,verrieten,version,versorge,versorgen,versorgt,versorgte,versorgten,versorgtes,viel,viele,vielen,vieler,vielerlei,vieles,vielleicht,vielmalig,vielmals,vier,voellig,voellige,voelligem,voelligen,voelliger,voelliges,voelligst,vollends,völlig,völlige,völligem,völligen,völliger,völliges,völligst,vollstaendig,vollstaendige,vollstaendigem,vollstaendigen,vollstaendiger,vollstaendiges,vollständig,vollständige,vollständigem,vollständigen,vollständiger,vollständiges,vom,von,vor,voran,vorbei,vorgestern,vorher,vorherig,vorherige,vorherigem,vorheriger,vorne,vorüber,vorueber,wachen,waehrend,waehrenddessen,waere,während,währenddessen,wann,war,wär,wäre,waren,wären,warst,wart,warum,was,weder,weg,wegen,weil,weiß,weit,weiter,weitere,weiterem,weiteren,weiterer,weiteres,weiterhin,weitestgehend,weitestgehende,weitestgehendem,weitestgehenden,weitestgehender,weitestgehendes,weitgehend,weitgehende,weitgehendem,weitgehenden,weitgehender,weitgehendes,welche,welchem,welchen,welcher,welches,wem,wen,wenig,wenige,weniger,wenigstens,wenn,wenngleich,wer,werde,werden,werdet,weshalb,wessen,weswegen,wichtig,wie,wieder,wiederum,wieso,wieviel,wieviele,wievieler,wiewohl,will,willst,wir,wird,wirklich,wirklichem,wirklicher,wirkliches,wirst,wo,wobei,wodurch,wofuer,wofür,wogegen,woher,wohin,wohingegen,wohl,wohlgemerkt,wohlweislich,wolle,wollen,wollt,wollte,wollten,wolltest,wolltet,womit,womoeglich,womoegliche,womoeglichem,womoeglichen,womoeglicher,womoegliches,womöglich,womögliche,womöglichem,womöglichen,womöglicher,womögliches,woran,woraufhin,woraus,worin,wuerde,wuerden,wuerdest,wuerdet,wurde,würde,wurden,würden,wurdest,würdest,wurdet,würdet,www,x,z.B.,zahlreich,zahlreichem,zahlreicher,zB,zb.,zehn,zeitweise,zeitweisem,zeitweisen,zeitweiser,ziehen,zieht,ziemlich,ziemliche,ziemlichem,ziemlichen,ziemlicher,ziemliches,zirka,zog,zogen,zu,zudem,zuerst,zufolge,zugleich,zuletzt,zum,zumal,zumeist,zumindest,zunächst,zunaechst,zur,zurück,zurueck,zusammen,zusehends,zuviel,zuviele,zuvieler,zuweilen,zwanzig,zwar,zwei,zweifelsfrei,zweifelsfreie,zweifelsfreiem,zweifelsfreien,zweifelsfreier,zweifelsfreies,zwischen,zwölf';
    var stop = stopwords.split(',');
    if (jQuery.inArray(text, stop) !== -1) {
      alert(form.attr('data-error-deny'));
      return false;
    }
  });

  jQuery(document).on('click', '.menu-toggle', function () {

    if (jQuery('.tunnel-menu.container').hasClass('-active')) {
      jQuery('#header-responsive.language, .tunnel-menu.container').removeClass(
        '-active'
      );
      jQuery('.tunnel-menu.container').slideUp();
      //jQuery("html, body, #site").css('overflow', 'visible');
    } else {
      jQuery('#header-responsive, .tunnel-menu.container').addClass('-active');
      jQuery('.tunnel-menu.container').slideDown();
      //jQuery("html, body, #site").css('overflow', 'hidden');
    }
  });

  jQuery(document).on(
    'click',
    '.responsive-menu.-active .header-menu .menu-left > li > a',
    function (e) {
      if (!jQuery(this).parent().hasClass('-active')) {
        jQuery(
          '.responsive-menu.-active .header-menu .menu-left > li.-active'
        ).removeClass('-active');
      } else {
        return true;
      }

      jQuery(this).parent().toggleClass('-active');
      e.preventDefault();
    }
  );

  jQuery(document).on(
    'click',
    '.footer-block > .row > ul > li > div > .fas',
    function () {
      var parent = jQuery(this).parent().parent().parent();

      if (parent.hasClass('-active')) {
        jQuery('.footer-block > .row > ul.-active').removeClass('-active');
        jQuery(this).addClass('fa-plus').removeClass('fa-minus');
      } else {
        jQuery('.footer-block > .row > ul.-active').removeClass('-active');
        jQuery('.footer-block > .row > ul > li > div > .fa-minus')
          .addClass('fa-plus')
          .removeClass('fa-minus');
        parent.addClass('-active');
        jQuery(this).addClass('fa-minus').removeClass('fa-plus');
      }
    }
  );

  jQuery(document).on(
    'click',
    'div.norm-element .norm-content .text',
    function (x) {
      var parent = jQuery(this).parents('div.norm-element');
      if (parent.hasClass('active')) {
        jQuery('.norm-content .norm-extra', parent).css('max-height', 0);
        parent.removeClass('active');
      } else {
        jQuery('.norm-element.active')
          .removeClass('active')
          .find('.norm-extra')
          .css('max-height', 0);
        var elements = jQuery('.norm-content .norm-extra li', parent).length;
        jQuery('.norm-content .norm-extra', parent).css(
          'max-height',
          40 * elements
        );
        parent.addClass('active');
      }
    }
  );

  jQuery(document).on(
    'click',
    "div[data-action='selectManufacturer']",
    function (x) {
      jQuery("div[data-action='selectManufacturer']").removeClass('active');
      jQuery(this).addClass('active');
      var manufacturer = jQuery(this).attr('data-manufacturer');
      var limit = jQuery('.load-norms').attr('data-count');
      if (manufacturer == 999999) {
        jQuery('.delete-filter').hide();
      } else {
        jQuery('.delete-filter').css('display', 'inline-block');
      }
      getData('norms', manufacturer, limit);
    }
  );

  jQuery(document).on('click', '.load-norms .more-button', function (x) {
    var manufacturer = jQuery(
      "div.active[data-action='selectManufacturer']"
    ).attr('data-manufacturer');
    var limit = jQuery('.load-norms').attr('data-count');
    jQuery('.norm-spinner', this).show();
    getData('norms', manufacturer, limit + 16, 1);
  });

  jQuery(document).on('click', '.load-servicenorms .more-button', function (x) {
    jQuery('.norm-spinner', this).addClass('.servicenorms-spinner').show();
    var service = jQuery('.load-servicenorms').attr('data-service');
    getData('servicenorms', service, 100, 1);
  });

  jQuery(document).on('click', "div[data-action='selectCategory']", function (
    x
  ) {
    jQuery("div[data-action='selectCategory']").removeClass('active');
    jQuery(this).addClass('active');
    var category = jQuery(this).attr('data-category');
    var limit = jQuery('.load-news').attr('data-count');
    var type = jQuery('[data-post-type]').data('post-type');
    getData(type, category, limit);
  });

  jQuery(document).on('click', '.news-container .more-button', function (x) {
    var category = jQuery("div.active[data-action='selectCategory']").attr(
      'data-category'
    );
    var limit = jQuery('.load-news').attr('data-count');
    var type = jQuery('[data-post-type]').data('post-type');
    jQuery('.news-spinner', this).show();
    getData(type, category, limit + 16, 1);
  });

  jQuery(document).on('click', "div[data-action='selectJobtag']", function (x) {
    jQuery("div[data-action='selectJobtag']").removeClass('active');
    jQuery(this).addClass('active');
    var jobtag = jQuery(this).attr('data-jobtag');
    var limit = jQuery('.load-jobs').attr('data-count');
    var type = jQuery('.load-jobs').attr('data-type');
    getData('jobs', type + '#' + jobtag, limit);
  });

  jQuery(document).on('click', '.jobs-container .more-button', function (x) {
    var jobtag = jQuery("div.active[data-action='selectJobtag']").attr(
      'data-jobtag'
    );
    var limit = jQuery('.load-jobs').attr('data-count');
    var type = jQuery('.load-jobs').attr('data-type');
    jQuery('.jobs-spinner', this).show();
    getData('jobs', type + '#' + jobtag, limit + 16, 1);
  });

  jQuery(document).on('mouseover', '.infocont ul li', function (x) {
    jQuery('.current').removeClass('current');
    jQuery(this).addClass('current');
    jQuery('.' + jQuery(this).attr('data-placeholder') + ' img').attr(
      'src',
      jQuery(this).attr('data-img')
    );
  });

  jQuery(document).on('click', '.service-overview-navi ul li', function () {
    jQuery('.service-overview-content').html(
      "<div class='row'><div class='col-sm-12 text-center'><i class='fa fa-spinner fa-pulse service-spinner'></i></div></div>"
    );
    jQuery('.service-overview-navi .current').removeClass('current');
    jQuery(this).addClass('current');
    jQuery(this).parent().parent().find('h5').addClass('current');

    //var scroll = jQuery(window).scrollTop();
    var position = jQuery('div.service-overview-content').offset().top - 150;

    //jQuery("html").animate({scrollTop: position}, 500);

    jQuery.post(
      ajax_object.ajax_url,
      {
        action: 'getservice',
        data: jQuery(this).attr('data-id'),
      },
      function (response) {
        jQuery('.service-overview-content').html(response);

        var deviceAgent = navigator.userAgent.toLowerCase();
        var agentID = deviceAgent.match(/(iPad|iPhone|iPod)/i);
        var isEdge = deviceAgent.match('edge');

        if (agentID) {
          jQuery('body').animate({ scrollTop: position + 'px' }, 500);
        } else if(isEdge){
          jQuery('body').animate({ scrollTop: position + 'px' }, 500);
        } else {
          jQuery('html').animate({ scrollTop: position + 'px' }, 500);
        }
      }
    );
  });

  jQuery(document).on('touchmove', 'responsive-menu', function (e) {
    e.preventDefault();
  });
});

function getData(type, data, limit, more) {
  if (!type) type = 'news';
  if (!data) data = 0;
  if (!limit) {
    if (type == 'news' || type == 'social_media') limit = 6;
    else limit = 16;
  }

  if (!more) more = 0;
  if (!more)
    jQuery('.load-' + type).html(
      "<div class='row'><div class='col-sm-12 text-center'><i class='fa fa-spinner fa-pulse " +
        type +
        "-spinner'></i></div></div>"
    );
  if (data == 999999) {
    jQuery('.load-' + type).html('');
  } else {
    jQuery.post(
      ajax_object.ajax_url,
      {
        action: 'get' + type,
        data: data,
        limit: limit,
      },
      function (response) {
        if (type == 'social_media') {
          type = 'news';
        }
        jQuery('.load-' + type)
          .attr('data-count', limit)
          .html(response);
        jQuery('.' + type + '-spinner').hide();
      }
    );
  }
}

function showSearchBar() {
  jQuery('.search-bar').toggleClass('-active');

  var el = jQuery('.search-bar').find("input[name='s']").get(0);
  var elemLen = el.value.length;

  el.selectionStart = elemLen;
  el.selectionEnd = elemLen;
  el.focus();
}

function headerSpace() {
  if (window.innerWidth > 940) {
    return;
  }

  if (document.querySelector('.page-template-nanongy_front')) {
    return;
  }

  var main = document.getElementById('site-main');
  main.style.marginTop = '0px';
  var header = document.querySelector('.header-menu-container.responsive-menu');

  var headerHeight = header.clientHeight;
  main.style.marginTop = headerHeight/2 + 'px';
}

function scrolledNavigation() {
  window.addEventListener('scroll', function () {
    var fixedHeader = document.querySelector('#site-header');
    if (jQuery(window).scrollTop() > 20) {
      //abuse 0 == false :)
      fixedHeader.classList.add('-scrolled');
      return;
    }

    fixedHeader.classList.remove('-scrolled');
  });
}
